import { render } from "./Berita.vue?vue&type=template&id=32aa6198&scoped=true"
import script from "./Berita.vue?vue&type=script&lang=js"
export * from "./Berita.vue?vue&type=script&lang=js"

import "./Berita.vue?vue&type=style&index=0&id=32aa6198&lang=scss&scoped=true"

import exportComponent from "/Users/hxp/Workspace/bintangmas-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32aa6198"]])

export default __exports__